// removed by extract-text-webpack-plugin
module.exports = {"results-info":"ResultsListInfo-module-results-info-2eXsa","resultsInfo":"ResultsListInfo-module-results-info-2eXsa","search-car":"ResultsListInfo-module-search-car-1Jl12","searchCar":"ResultsListInfo-module-search-car-1Jl12","search-item":"ResultsListInfo-module-search-item-HAtrt","searchItem":"ResultsListInfo-module-search-item-HAtrt","bold":"ResultsListInfo-module-bold-3qjko","results-number":"ResultsListInfo-module-results-number-222oT","resultsNumber":"ResultsListInfo-module-results-number-222oT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResultsListInfo/ResultsListInfo.module.scss
// module id = 933
// module chunks = 0